
export interface Profile {
  id?: number,
  first_name: string,
  last_name: string,
  username: string,
  is_staff: boolean,
  is_active: boolean,
  date_joined: string;
}

export function defaultProfile(): Profile {
  return {
    id: undefined,
    first_name: '',
    last_name: '',
    username: '',
    is_staff: false,
    is_active: false,
    date_joined: '',
  };
} 